import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, LinkProps } from 'react-router-dom'

import styles from './Skip.module.scss'

interface SkipProps extends LinkProps {}

const Skip = ({ ...linkProps }: SkipProps) => {
  const { t } = useTranslation()

  return (
    <Link {...linkProps} className={styles.link}>
      {t('skip.pretermit')}
    </Link>
  )
}

export default Skip
